
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/cercador",
      function () {
        return require("private-next-pages/corporatiu/cercador/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/cercador"])
      });
    }
  